import React, { FC, ReactNode } from "react";
import { AppPageKey } from "./AppPageKey";

export const AppPageKeyContext = React.createContext<AppPageKey>(
  undefined as unknown as AppPageKey,
);

export const AppPageKeyProvider: FC<{ appPageKey: AppPageKey; children: ReactNode }> = (
  props,
) => {
  return (
    <AppPageKeyContext.Provider value={props.appPageKey}>
      {props.children}
    </AppPageKeyContext.Provider>
  );
};
